import { makeStyles } from '@mui/styles'

export default makeStyles((theme: any) => ({
    Button: {
        fontWeight: 700,
    },
    ButtonLarge: {
        width: '100%',
    },
    ButtonActive: {
        position: 'relative',
        background: theme.palette.lightGrey.half,
        '&::before': {
            content: '""',
            position: 'absolute',
            top: '-0.3rem',
            right: '-0.3rem',
            width: '1rem',
            height: '1rem',
            borderRadius: '100%',
            background: theme.palette.primary.main,
        },
    },
    ButtonSmall: {
        padding: '.5rem',
        minWidth: 0,
    },
    ButtonTextBlack: {
        color: theme.palette.typography.main,
        fontWeight: 700,
        border: `2px solid ${theme.palette.typography.main}`,
        '&:hover': {
            borderColor: 'transparent',
        },
    },
    ButtonTextPrimary: {
        fontWeight: 700,
        textDecoration: 'underline',
        color: theme.palette.primary.main,
        '& *': {
            color: theme.palette.primary.main,
        },
        '&:hover': {
            textDecoration: 'none',
            color: theme.palette.primary.light,
            '& *': {
                color: theme.palette.primary.light,
            },
        },
    },
    ButtonTextBlackFlat: {
        color: theme.palette.typography.main,
        fontWeight: 700,
        border: 'none',
    },
    ButtonTextBlackUnderlined: {
        position: 'relative',
        color: theme.palette.typography.main,
        fontWeight: 700,
        '&::before': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: 3,
            width: '100%',
            background: theme.palette.typography.main,
            borderRadius: 100,
            transform: 'translateY(0)',
            opacity: 1,
            transition: 'transform .13s ease-in-out, opacity .13s ease-in-out',
        },
        '&:hover::before': {
            transform: 'translateY(-125%)',
            opacity: 0,
        },
    },
    ButtonBlack: {
        background: theme.palette.typography.main,
        borderRadius: '8px',
        color: '#ffffff',
        display: 'flex',
        padding: '15px 32px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        alignSelf: 'stretch',
        '&:hover': {
            background: theme.palette.typography.hover,
        },
        '&.Mui-disabled': {
            background: '#E0E0E0',
            color: '#8B8B8B !important',
        },
    },
    ButtonWhite: {
      background: '#ffffff',
      borderRadius: '8px',
      color: '#040404 !important',
      display: 'flex',
      padding: '14px 24px 14px 20px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '12px',
      flex: '1 0 0',
      border: `2px solid ${theme.palette.typography.main}`,
      '&:hover': {
          background: theme.palette.action.hover,
      },
      '&.Mui-disabled': {
          background: '#E0E0E0',
          color: '#8B8B8B !important',
          border: 'none',
      },
},
    ButtonConsultation: {
        background: theme.palette.consultation.main,
        color: '#ffffff',
        '&:hover': {
            background: theme.palette.consultation.hover,
        },
    },
    ButtonConsultationShadow: {
        boxShadow: `0px 1px 12px ${theme.palette.consultation.shadow}`,
    },
    ButtonMinWidth: {
        minWidth: '14rem',
    },
    ButtonDelete: {
        background: theme.palette.red.main,
        color: '#ffffff',
        '&:hover': {
            background: theme.palette.red.hover,
        },
    },
    ButtonDeleteLight: {
        background: theme.palette.red.ultraLight,
        color: theme.palette.red.main,
        '&:hover': {
            background: theme.palette.red.hoverUltraLight,
        },
    },
    ButtonDeleteShadow: {
        boxShadow: `0px 1px 12px ${theme.palette.red.shadow}`,
    },
    ButtonCancel: {
        background: theme.palette.lightGrey.lightest,
        color: `${theme.palette.typography.main} !important`,
    },
    ButtonSelectorWrapper: {
        border: `2px solid ${theme.palette.typography.main}`,
        borderRadius: 12,
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
    },
    ButtonSelectorWrapperLargeDisabled: {
        borderColor: theme.palette.lightGrey.medium,
    },
    ButtonSelectorWrapperLarge: {
        width: '100%',
    },
    ButtonSelector: {
        flex: 1,
        borderRadius: 0,
        whiteSpace: 'nowrap',
        fontSize: '.8rem',
        [theme.breakpoints.up('md')]: {
            fontSize: '1rem',
        },
        '&:hover': {
            background: theme.palette.typography.ultraLight,
        },
        '&.MuiButton-contained': {
            background: theme.palette.typography.main,
        },
    },
}))
